import { array, option } from 'fp-ts';
import { constFalse, pipe } from 'fp-ts/function';
import { createSelector } from 'reselect';
import { values } from '@mews/fp';
import { getEntities } from '../entities/getEntities';
import { getSelectedHotelId } from '../resourceOrder/selectors';

const getProducts = createSelector(getEntities, (entities) => entities.products);
const getProductsMeta = createSelector(getProducts, (entities) => entities.meta);
const getCurrentProductsMeta = createSelector(getProductsMeta, getSelectedHotelId, (productsMeta, enterpriseId) =>
    option.fromNullable(productsMeta[enterpriseId])
);

export const areCurrentProductsFetching = createSelector(getCurrentProductsMeta, (currentEnterpriseProductsMeta) =>
    pipe(
        currentEnterpriseProductsMeta,
        option.map(({ isFetching }) => isFetching),
        option.getOrElse(constFalse)
    )
);

export const areAnyProductsFetching = createSelector(getProductsMeta, (productsMeta) =>
    pipe(
        productsMeta,
        values,
        array.some(({ isFetching }) => isFetching)
    )
);

export const haveCurrentProductsFailed = createSelector(getCurrentProductsMeta, (currentEnterpriseProductsMeta) =>
    pipe(
        currentEnterpriseProductsMeta,
        option.map(({ hasFailed }) => hasFailed),
        option.getOrElse(constFalse)
    )
);
